<template>
  <div class="form-row">
    <div class="col">
      <select v-model="unit" @change="input" class="form-control">
        <option v-for="option in allowedOptions" :value="option">{{ option }}</option>
      </select>
    </div>
    <div class="col">
      <input v-if="unit=='em'" type="number" step="0.1" class="form-control" v-model="handler" @input="input()">
      <input v-else-if="unit!='auto'" type="number" class="form-control" v-model="handler" @input="input()">
    </div>
  </div>
</template>

<script>
export default {
  props: ['value','config'],

  data(){
    return {
      handler:'',
      unit:'',
      options:[ '', 'auto', 'px', 'em', '%' ]
    }
  },
  computed:{
    allowedOptions(){
      if(!this.allowed) return this.options;
      return this.allowed;
    },
    allowed(){
      if(!this.config.vars || !this.config.vars.allowed) return false;
      return this.config.vars.allowed;
    }
  },
  mounted(){
      if(!this.value) return;
      var match = this.value.match(/^(-?[.\d]+)(px|em|rem|%|vw|vh)$/);
      if(match){
        this.handler = match[1];
        this.unit = match[2];
      } else {
        this.unit = this.value;
      }
  },
  methods:{

    input(){
        var newval = this.handler+this.unit;
        if(!this.unit) newval = '';
        if(this.unit=='auto') newval = 'auto';

        this.$emit('change',newval);
    },

  }

}
</script>
